<template>
	<div class="footer-container">
		<div class="rrss">
			<a href="https://www.linkedin.com/company/105811041" target="_blank" class="rrss_btn linkedin" alt="Linkedin"></a>
			<a href="https://x.com/PressBeePallet" target="_blank" class="rrss_btn twitter" alt="Twitter"></a>
		</div>
		<nav class="footer-menu no-margin">
			<a href="https://beepallet.com/blog/sobre-nosotros/" class="menu-btn" target="_blank" rel="noopener">Sobre nosotros</a>
			<a href="https://beepallet.com/blog/contacto/" class="menu-btn" target="_blank" rel="noopener">Contáctanos</a>
		</nav>
		<nav class="footer-menu">
			<router-link v-for="menuItem in menuFooter" 
						:key="menuItem.id" 
						:to="{ name: menuItem.link }">
				{{ menuItem.label }}
			</router-link>
			<router-link to="/sitemap.xml" target="_blank" rel="noopener">Sitemap</router-link>
		</nav>
		<div class="bottom-container">
			<span class="copyright">COPYRIGHT ® {{ currentYear }} BeePallet - Todos los derechos reservados.</span>
			<img :src="beepalletLogo" alt="Logo BeePallet">
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import beepalletLogo from '@/assets/images/BeePallet_Logo_Black.png';

const menuFooter = ref([
	{ id: 1, label: 'Política de privacidad', link: 'privacy_policy' },
	{ id: 2, label: 'Condiciones del servicio', link: 'terms_conditions' },
	{ id: 3, label: 'Política de Cookies', link: 'cookies_policy' }
]);

const currentYear = new Date().getFullYear();
</script>

<style lang="scss" scoped>
@import "FooterComponent";
</style>